/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function() {
    /**
     * Sets or removes .focus class on an element.
     */
    const toggleFocus = (event) => {
        if (event.type === 'click') {
            const target = event.target;
            const menuItem = target.parentNode;

            event.preventDefault();

            for (const link of menuItem.parentNode.children) {
                if (menuItem !== link) {
                    link.classList.remove('focus');
                }
            }
            menuItem.classList.toggle('focus');
        }
    };

    const siteNavigation = document.getElementById('site-navigation');

    // Return early if the navigation doesn't exist.
    if (! siteNavigation) {
        return;
    }

    const navigationToggle = document.querySelector('[data-navigation-toggle]');

    // Return early if the button doesn't exist.
    if ('undefined' === typeof navigationToggle) {
        return;
    }

    // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
    navigationToggle.addEventListener('click', function() {
        document.body.classList.toggle('toggled');

        if (navigationToggle.getAttribute('aria-expanded') === 'true') {
            navigationToggle.setAttribute('aria-expanded', 'false');
        } else {
            navigationToggle.setAttribute('aria-expanded', 'true');
        }
    });

    // Get all the link elements within the menu.
    const links = siteNavigation.getElementsByTagName('a');

    // Get all the link elements with children within the menu.
    const linksWithChildren = siteNavigation.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

    // Toggle focus each time a menu link is focused or blurred.
    // for (const link of links) {
    //     link.addEventListener('pointerdown', toggleFocus, true);
    //     link.addEventListener('blur', toggleFocus, true);
    // }

    // Toggle focus each time a menu link with children receive a touch event.
    for (const link of linksWithChildren) {
        link.addEventListener('click', toggleFocus, false);
    }

    /////////////////////////
    // Show menu on scroll //
    /////////////////////////
    // const topBar = document.getElementById('top-bar');

    // let header;
    // header = pageHasHeaderSlider() ? document.querySelector('.entry-header') : undefined;
    // header = pageHasEntryHeaderWithBackground() ? document.querySelector('.entry-content').children[0] : undefined;

    // const resizeEvent = new Event('resize');
    let lastScrollTop = 0;

    // window.addEventListener('resize', function (event) {
    // const windowHeight = window.innerHeight;

    // if (windowHeight <= 680) {
    //     header.style.height = windowHeight + 150;
    //     document.body.style.marginTop = topBarHeight;
    // } else {
    //     header.style.height = windowHeight;
    //     document.body.style.marginTop = windowHeight + topBarHeight;
    // }
    // });

    // window.dispatchEvent(resizeEvent);

    window.addEventListener('scroll', function() {
        const currentScroll = window.scrollY;
        const scrollDirection = currentScroll <= lastScrollTop ? 'up' : 'down';

        if (scrollDirection === 'up') {
            // topBar.style.translate = 0;
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        } else if (currentScroll > 1200) {
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
        }

        if (currentScroll > 300) {
            document.body.classList.add('top-bar-background');
        } else {
            document.body.classList.remove('top-bar-background');
        }

        lastScrollTop = currentScroll;
    });
}());
